import React from "react";
import "../ShareHolderInfo.scss";

import ddCompliance2024 from "../../../files/shareholder-info/Revised Dividend Distribution Compliance Report- 2024.pdf";

import ddCompliance2023 from "../../../files/shareholder-info/Dividend Distribution Compliance Report-2023.pdf";
import ddCompliance2022 from "../../../files/shareholder-info/Dividend Distribution Compliance Report-2022.pdf";
import ddCompliance2021 from "../../../files/shareholder-info/Dividend Distribution Compliance Report-2021.pdf";
import ddCompliance2020 from "../../../files/shareholder-info/Dividend Distribution Compliance Report-2020-converted.pdf";

const DividendCompliance = () => {
  return (
    <>
      <div className="shareholder_info">
        <div className="container">
          <div className="heading_box">
            Dividend Distribution Compliance Report
          </div>
          <div className="dividend_report_link">
            <ul>
              <li>
                <a href={ddCompliance2024} target="_blank" rel="noreferrer">
                  Dividend Distribution Compliance Report-2024
                </a>
              </li>

              <li>
                <a href={ddCompliance2023} target="_blank" rel="noreferrer">
                  Dividend Distribution Compliance Report-2023
                </a>
              </li>

              <li>
                <a href={ddCompliance2022} target="_blank" rel="noreferrer">
                  Dividend Distribution Compliance Report-2022
                </a>
              </li>

              <li>
                <a href={ddCompliance2021} target="_blank" rel="noreferrer">
                  Dividend Distribution Compliance Report-2021
                </a>
              </li>

              <li>
                <a href={ddCompliance2020} target="_blank" rel="noreferrer">
                  Dividend Distribution Compliance Report-2020
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default DividendCompliance;
